<div #imageContainer class="image-container">

    <img class="image" [src]="data?.presignedUrl" alt="Media" />
    <div class="image-actions">

        <button type="button" class="action-button" (click)="downloadImage()" title="Download">
            <span>⬇</span>
        </button>

        <button type="button" *ngIf="!isFullscreen" class="action-button" (click)="enterFullscreen()" title="Fullscreen">
            <span>⛶</span>
        </button>

        <!-- Exit fullscreen button -->
        <button *ngIf="isFullscreen" type="button" class="action-button" (click)="exitFullscreen()">
            ✕
        </button>

    </div>

</div>